import { HashRouter, NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { getStaff, clearSession, getToken } from './lib/api';
import { SignIn } from './pages/SignIn';
import { Dashboard } from './pages/Dashboard';
import { DeviceRegistry } from './pages/DeviceRegistry';
import { DeviceDetail } from './pages/DeviceDetail';
import { Financials } from './pages/Financials';
import { Integrators } from './pages/Integrators';
import { Firmware } from './pages/Firmware';
import { Tickets } from './pages/Tickets';

/**
 * NeteGate Central console (wireframes C1–C6).
 *
 * HashRouter rather than BrowserRouter: this is served as static assets behind
 * whatever the deployment puts in front of it, and hash routing needs no
 * server-side rewrite rules to survive a page refresh on a deep link.
 */
function Shell() {
  const staff = getStaff();
  if (!getToken() || !staff) return <Navigate to="/signin" replace />;

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">
          Nete<span>Gate</span> Central
        </div>
        <nav className="nav">
          <NavLink to="/dashboard">Fleet dashboard</NavLink>
          <NavLink to="/devices">Device registry</NavLink>
          <NavLink to="/finance">Financials &amp; tax</NavLink>
          <NavLink to="/integrators">System integrators</NavLink>
          <NavLink to="/firmware">Firmware</NavLink>
          <NavLink to="/tickets">Support tickets</NavLink>
        </nav>
        <div className="sidebar-footer">
          <div>{staff.fullName}</div>
          <div className="muted" style={{ marginBottom: 10 }}>
            {staff.role}
          </div>
          <button
            className="secondary"
            style={{ width: '100%', marginBottom: '1rem' }}
            onClick={() => {
              clearSession();
              window.location.hash = '#/signin';
            }}
          >
            Sign out
          </button>
          <div className="qubow-footer muted" style={{ fontSize: '12px', textAlign: 'center' }}>
            © 2026 Developed by <b><a href="https://www.qubow.com" target="_blank" aria-label="Qubow" style={{ color: 'inherit', textDecoration: 'none' }}>Qubow</a></b>
          </div>
        </div>
      </aside>
      <main className="main">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/devices" element={<DeviceRegistry />} />
          <Route path="/devices/:deviceId" element={<DeviceDetail />} />
          <Route path="/finance" element={<Financials />} />
          <Route path="/integrators" element={<Integrators />} />
          <Route path="/firmware" element={<Firmware />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/signin" element={<SignIn />} />
        <Route path="/*" element={<Shell />} />
      </Routes>
    </HashRouter>
  );
}
